import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PageMeta from "@/components/PageMeta";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";

const ImprintPage = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background text-foreground">
      <PageMeta
        title="Imprint — rawResponse {Labs}"
        description="Legal information and company details for Raw Response Labs UG (haftungsbeschränkt), Berlin."
      />
      <Navbar />

      <main className="pt-24 pb-20">
        <div className="container max-w-3xl">
          <a
            href="/"
            className="inline-flex items-center gap-1.5 text-[13px] font-mono text-muted-foreground hover:text-foreground transition-colors mb-8"
          >
            <ArrowLeft size={14} />
            {t("imprint.back")}
          </a>

          <h1 className="text-3xl md:text-4xl font-mono font-bold mb-10">{t("imprint.title")}</h1>

          <div className="space-y-8 text-[14px] font-mono text-muted-foreground leading-relaxed">
            <p className="text-[12px] text-muted-foreground/60">{t("imprint.legalNote")}</p>

            <section>
              <h2 className="text-foreground font-semibold text-[15px] mb-2">{t("imprint.company")}</h2>
              <p>Raw Response Labs UG (haftungsbeschränkt)</p>
              <p className="text-muted-foreground/70">{t("imprint.subsidiary")}</p>
              <p className="mt-2">Urbanstr. 71</p>
              <p>10967 Berlin</p>
              <p>Germany</p>
            </section>

            <section>
              <h2 className="text-foreground font-semibold text-[15px] mb-2">{t("imprint.register")}</h2>
              <p>HRB 284973 B</p>
              <p>Registergericht: Amtsgericht Charlottenburg</p>
            </section>

            <section>
              <h2 className="text-foreground font-semibold text-[15px] mb-2">{t("imprint.representedBy")}</h2>
              <p>Levent Valente</p>
            </section>

            <section>
              <h2 className="text-foreground font-semibold text-[15px] mb-2">{t("imprint.contact")}</h2>
              <p>Phone: +49 (0) 1520 / 8544 838</p>
              <p>
                Email:{" "}
                <a href="mailto:hello@webblitz.ai" className="text-primary hover:text-primary/80 transition-colors">
                  hello@webblitz.ai
                </a>
              </p>
            </section>

            <section>
              <h2 className="text-foreground font-semibold text-[15px] mb-2">{t("imprint.euDispute")}</h2>
              <p>
                {t("imprint.euDisputeText")}{" "}
                <a
                  href="https://ec.europa.eu/consumers/odr/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary hover:text-primary/80 transition-colors"
                >
                  https://ec.europa.eu/consumers/odr/
                </a>
              </p>
              <p className="mt-2">{t("imprint.emailAbove")}</p>
            </section>

            <section>
              <h2 className="text-foreground font-semibold text-[15px] mb-2">{t("imprint.consumerDispute")}</h2>
              <p>{t("imprint.consumerDisputeText")}</p>
            </section>

            <div className="section-divider w-full my-10" />

            <p className="text-[12px] text-muted-foreground/50">
              © {new Date().getFullYear()} Valente Ventures GmbH. All rights reserved.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ImprintPage;
